import React, { useState, useEffect } from 'react';
import Modal from '../shared/Modal';
import Button from '../shared/Button';

const AutoAssignModal = ({ isOpen, onClose, onConfirm, waitingCount, selectedDate }) => {
    const [date, setDate] = useState(selectedDate || new Date().toISOString().split('T')[0]);
    const [mode, setMode] = useState('relative'); // 'relative' (now + delay) or 'fixed' (specific hour)
    const [minDelay, setMinDelay] = useState(60); // Minutes
    const [startHour, setStartHour] = useState(8); // Hour (0-23)

    useEffect(() => {
        if (selectedDate) {
            setDate(selectedDate);
        }
    }, [selectedDate]);

    const handleConfirm = () => {
        onConfirm({
            date,
            mode,
            minDelayMinutes: mode === 'relative' ? parseInt(minDelay) : 0,
            startHour: mode === 'fixed' ? parseInt(startHour) : 0
        });
        onClose();
    };

    const isToday = new Date().toISOString().split('T')[0] === date;

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title="Otomatik Rezervasyon Atama"
            maxWidth="500px"
        >
            <div className="flex flex-col gap-lg">
                <div className="bg-surface-secondary p-md rounded-lg border border-border">
                    <div className="flex items-center gap-md text-primary font-bold">
                        <span className="text-xl">⚡</span>
                        <div>
                            <div>Hızlı Planlama Sihirbazı</div>
                            <div className="text-xs text-secondary font-normal">
                                {waitingCount} adet bekleyen rezervasyon için en uygun slotları bulur.
                            </div>
                        </div>
                    </div>
                </div>

                <div className="form-group">
                    <label className="form-label">Planlama Tarihi</label>
                    <input
                        type="date"
                        className="input"
                        value={date}
                        min={new Date().toISOString().split('T')[0]}
                        onChange={(e) => setDate(e.target.value)}
                    />
                </div>

                <div className="card bg-surface border border-border p-md">
                    <label className="form-label mb-sm block">Başlangıç Zamanı</label>

                    <div className="flex flex-col gap-md">
                        {/* Option 1: Relative (Only if Today) */}
                        <label className={`flex items-center gap-md p-sm rounded cursor-pointer transition-colors ${mode === 'relative' ? 'bg-primary-soft' : 'hover:bg-surface-hover'}`}>
                            <input
                                type="radio"
                                name="startMode"
                                checked={mode === 'relative'}
                                onChange={() => setMode('relative')}
                                disabled={!isToday}
                                className="accent-primary"
                            />
                            <div className="flex-1">
                                <div className="font-bold text-sm">Şu andan itibaren</div>
                                {mode === 'relative' && (
                                    <div className="mt-xs flex items-center gap-sm">
                                        <input
                                            type="number"
                                            className="input py-1 px-2 text-sm w-20 text-center"
                                            value={minDelay}
                                            onChange={(e) => setMinDelay(Math.max(0, parseInt(e.target.value) || 0))}
                                            min="0"
                                        />
                                        <span className="text-xs text-secondary">dakika sonra başla</span>
                                    </div>
                                )}
                            </div>
                        </label>

                        {/* Option 2: Fixed Hour */}
                        <label className={`flex items-center gap-md p-sm rounded cursor-pointer transition-colors ${mode === 'fixed' ? 'bg-primary-soft' : 'hover:bg-surface-hover'}`}>
                            <input
                                type="radio"
                                name="startMode"
                                checked={mode === 'fixed'}
                                onChange={() => setMode('fixed')}
                                className="accent-primary"
                            />
                            <div className="flex-1">
                                <div className="font-bold text-sm">Belirli bir saatten itibaren</div>
                                {mode === 'fixed' && (
                                    <div className="mt-xs flex items-center gap-sm">
                                        <select
                                            className="input py-1 px-2 text-sm w-full"
                                            value={startHour}
                                            onChange={(e) => setStartHour(parseInt(e.target.value))}
                                        >
                                            {Array.from({ length: 24 }).map((_, i) => (
                                                <option key={i} value={i}>
                                                    {i.toString().padStart(2, '0')}:00
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                )}
                            </div>
                        </label>
                    </div>
                </div>

                <div className="flex justify-end gap-md mt-sm">
                    <Button variant="secondary" onClick={onClose}>İptal</Button>
                    <Button variant="primary" onClick={handleConfirm}>
                        🚀 Planlamayı Başlat
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default AutoAssignModal;
